<template>
  <ui-dialog
    :title="$t('message.permissions.facilitiesInGroupTitle')"
    :show="show"
    @input="$emit('close')"
    custom-class="facilities-dialog"
  >
    <FacilitiesListContent
      :items="currentPageFacilities"
      :list-loading="listLoading"
      :page="page"
      :per-page="perPage"
      :page-options="pageOptions"
      :total-count="totalCount"
      :member="member"
      :placeholder="$t('message.permissions.facilitySearchPlaceholder')"
      preview-mode
      item-subtitle-field="formattedAddress"
      @handle-change="handlePageChange"
    />
  </ui-dialog>
</template>

<script>
import { companyMember } from "@/helpers/mixins/company-member";
import FacilitiesListContent from "@/components/Permissions/FacilitiesListContent";
import { mapActions, mapState } from "vuex";

export default {
  name: "FacilitiesGroupDetailsDialog",
  mixins: [companyMember],
  components: {
    FacilitiesListContent
  },
  props: {
    show: {
      type: Boolean,
      default: true
    },
    id: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState({
      currentPageFacilities: state => state.facilities.currentPageFacilities,
      totalCount: state => state.facilities.totalCount,
      facilitiesGroups: state =>
        state.facilitiesGroups.currentPageFacilitiesGroups
    })
  },
  data() {
    return {
      page: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200],
      listLoading: false
    };
  },
  methods: {
    ...mapActions({
      fetchAllFacilitiesGroupsIds: "facilitiesGroups/fetchFacilitiesGroupsIds"
    }),
    async handlePageChange({ page, perPage }) {
      this.page = page;
      this.perPage = perPage;
      await this.fetchFacilities();
    },

    async fetchFacilities() {
      this.listLoading = true;

      const params = {
        page: this.page,
        perPage: this.perPage,
        groups: [this.id]
      };

      await this.$store.dispatch("facilities/fetchFacilities", params);
      this.listLoading = false;
    }
  },

  created() {
    this.fetchFacilities();
  }
};
</script>
